import { atom } from 'jotai'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

const customerId = cookies.get('customerId')

export const customerIdAtom = atom(customerId || '')
